import {BaseFormModel} from './base-form-model';

export class OrganizationMarketingEmail extends BaseFormModel<OrganizationMarketingEmail> {
    id: number;
    email: string;
    parentId: number;
}
